import { render, staticRenderFns } from "./SFormInformationComp.vue?vue&type=template&id=7c786396&"
import script from "./SFormInformationComp.vue?vue&type=script&lang=js&"
export * from "./SFormInformationComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports